module.exports = __webpack_public_path__ + "static/media/list-leaf.4fa750cd.svg";